<template>
  <div id="app">
    <div id="header">
      <img class="headerLogo" src="img/storyLink-grey.png">
    </div>
    <div class="navBar" v-if="$route.name!=='sso'">
      <div class="navLink" @click="goToRoute('installers')">Installers</div>
      <div class="navLink" @click="goToRoute('docs')">Documentation</div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  methods:{
    goToRoute(name){
      this.$router.push(name)
    }
  }
}

</script>

<style>

html, body {
  font-family: Avenir, Helvetica, Arial, sans-serif !important;
}

#app {
  margin: auto;
  font-family: 'Roboto', sans-serif;
  font-family: Avenir, Helvetica, Arial, sans-serif !important;
  color: #4a4a4a;
  text-align: center;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
#header {
  padding: 2rem;
  font-size: 1.5rem;
  font-weight: 300;
}
.headerLogo{
  width: 180px;
  height: auto;
}

.navBar{
  display:flex;
  flex-direction: row;
  align-content: center; 
  align-items: baseline; 
  justify-content: center;
  width: 100%;
  height: auto;
  margin-top: .5rem;
  margin-bottom: 2rem;
  text-align: center;
}

.navLink{
  width: 16rem;
  height: auto;
  margin: 0 1rem;
  text-align: center;
  cursor: pointer;
}

.navLink:hover{
  font-weight: bold;
}
</style>
